    
import React from "react";

function ResultItem(props) {    
  return (
        <li className="list-group-item d-flex align-items-center">
          <a href={props.path} className="d-flex align-items-center w-100">
            <div className="d-flex flex-column">
                  <span className="font-weight-bold">{props.title}</span>
                  <small className="black">{props.info}</small>
              </div>
              <div className="d-flex flex-row ml-auto justify-content-end">
                  {
                      props.iconchecker.IsMultilingual &&
                      <a className="ml-auto" tabindex="0" data-toggle="popover" data-placement="top" data-content={props.title + " speaks a language other than English, Click for more information."} aria-label={props.title + " speaks a language other than English, Click for more information."} data-original-title="" title="" target="_blank">
                          <img src="/content/images/diverse-communities-blue-circle.svg" height="32" width="32" alt="" />
                      </a>
                  }
                  {
                    props.iconchecker.IsSpecialistCancerTypeLink &&
                    <a className="ml-auto" href={props.iconchecker.SpecialistCancerCentreLink} tabindex="0" data-toggle="popover" data-placement="top" data-content={props.title + " is a specialist cancer centre for this cancer type. Click for more details."} aria-label={props.title + " is a specialist cancer centre for this cancer type. Click for more details."} data-original-title="" title="" target="_blank">
                          <img src="/content/images/specialist-centre-inv.svg" height="32" width="32" alt="" />
                    </a>
                  }
                  {
                      props.iconchecker.IsEngagedInPRMs && props.iconchecker.PatientReportedMeasuresLink &&
                      <a className="ml-auto" href={props.iconchecker.PatientReportedMeasuresLink} tabindex="0" data-toggle="popover" data-placement="top" data-content={props.title + " collects patient reported measures. Click for more information."} aria-label={props.title + " collects patient reported measures. Click for more information. (opens in new window)."} data-original-title="" title="" target="_blank">
                          <img src="/content/images/patient-reported-measures-blue-circle.svg" height="32" width="32" alt="" />
                      </a>
                  }
                  {
                      props.iconchecker.HasClinicalTrial && props.iconchecker.ClinicalTrialLink &&
                      <a className="ml-auto" href={props.iconchecker.ClinicalTrialLink} tabindex="0" data-toggle="popover" data-placement="top" data-content={props.title + " has active cancer clinical trials. Click for more information."} aria-label={props.title + " has active cancer clinical trials. Click for more information (opens in new window)."} data-original-title="" title="" target="_blank">
                          <img src="/content/images/clinical-trial-inv.svg" height="32" width="32" alt="" />
                      </a>
                  }
              </div>
              <div>
                  <span className="ml-2 fas fa-chevron-right fa-fw onhover"></span>
              </div>
          </a>
        </li>
  );
}

export default ResultItem;